// TODO: clean this up while building the new product page. Maybe use the default product form, and add the accessory fee logic to onCartUpdate in cart.js

// A reusable function to update the hidden year input from the URL
function updateYearInput() {
  // Find the input field every time, in case the DOM was updated
  const yearInput = document.querySelector('input[name="properties[_Year]"], input[name="properties[year]"]');
  if (!yearInput) return;

  // Read the current URL's parameters
  const params = new URLSearchParams(window.location.search);
  const year = params.get('year');

  if (year) {
    yearInput.value = year;
  }
}



document.addEventListener('DOMContentLoaded', () => {
	updateYearInput();

	const form = document.querySelector('form[action$="/cart/add"]');
	const btns = document.querySelectorAll('#btnAddToCart');
  if (!form || !btns) return;
	
  const drawerElement = document.querySelector('cart-drawer');
  const quantityInput = document.querySelector('#Quantity');
  const yearInput = document.querySelector('[name="properties[year]"]');

  form.addEventListener('submit', async (e) => {
		e.preventDefault();
		console.log("sidebar");
		
    const formData = new FormData(form);
    const variantId = parseInt(formData.get('id'), 10);
    if (!variantId) return;
		
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    const year = yearInput ? yearInput.value.trim() : '';
		
    const item = { id: variantId, quantity };
    if (year) {
      item.properties = { year };
    }

		btns.forEach((btn) => {
			btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Adding ...';
		});

    try {
      // Add selected item to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });

      // Refresh UI
      await refreshCartSections();
      drawerElement?.open();

    } catch (err) {
      console.error('Add to cart failed:', err);
    } finally {
			btns.forEach((btn) => {
				btn.innerHTML = window.variantStrings.addToCart;
			});
		}
  });
});

async function refreshCartSections(sections) {
	if (!sections) {
		const sectionsToRender = 'cart-icon-bubble,cart-drawer,main-cart-items';
		const res = await fetch(`${window.location.pathname}?sections=${sectionsToRender}`);

		sections = await res.json();
	}

	// Update cart icon bubble
	const iconHtml = sections["cart-icon-bubble"];
	if (iconHtml) {
		const iconTarget = document.getElementById("cart-icon-bubble");
		if (iconTarget) {
			const parsedIcon = new DOMParser().parseFromString(iconHtml, "text/html").body
				.firstElementChild.innerHTML;
			if (parsedIcon) iconTarget.innerHTML = parsedIcon;
		}
	}

	// Update and open cart drawer
	const drawerHtml = sections["cart-drawer"];
	if (drawerHtml) {
		const drawerTarget = document.querySelector("#CartDrawer");
		const parsedDrawer = new DOMParser()
			.parseFromString(drawerHtml, "text/html")
			.querySelector("#CartDrawer");
		const drawerElement = document.querySelector("cart-drawer");

		if (drawerTarget && parsedDrawer) {
			drawerTarget.innerHTML = parsedDrawer.innerHTML;
		}

		if (drawerElement) {
			// Check if the drawer content has cart items
			const hasItems = parsedDrawer.querySelector(".cart-item:not(.cart-upsell-item)") !== null;

			if (!hasItems) {
				drawerElement.classList.add("is-empty");
			} else {
				drawerElement.classList.remove("is-empty");
			}
		}
	}

	const mainCartItemsHtml = sections["main-cart-items"];
	const cartItemsElement = document.querySelector("cart-items");
	if (mainCartItemsHtml && cartItemsElement) {
		const parsedMainCartItems = new DOMParser()
			.parseFromString(mainCartItemsHtml, "text/html")
			.querySelector("cart-items");

		cartItemsElement.replaceWith(parsedMainCartItems);
	}
}
